export default {"src":"/_next/static/media/mtgstocks.17989e1a.svg","height":500,"width":507,"blurWidth":0,"blurHeight":0};